<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

@if (formLoading) {
  <div>
    <mat-spinner></mat-spinner>
  </div>
}

<h2>{{formTitle}}</h2>

<form [formGroup]="form1" class="d-flex flex-wrap">

  @if (showCheckInDateRange) {
    <span class="my-2 d-block">
      <p-calendar inputId="start" placeholder="CHECKIN DATE" formControlName="formCheckInDateRange" [style]="{'width':'125px'}" appendTo="body" selectionMode="single">
      </p-calendar>&nbsp;&nbsp;
    </span>
  }

  @if (showCheckOutDateRange) {
    <span class="my-2 d-block">
      <p-calendar inputId="stop" placeholder="CHECKOUT DATE" formControlName="formCheckOutDateRange" [style]="{'width':'125px'}" appendTo="body" selectionMode="single">
      </p-calendar>&nbsp;&nbsp;
    </span>
  }

  @if (showReservationStatus) {
    <span class="my-2 d-block">
      <p-multiSelect [options]="constantService.reservationStatuses" defaultLabel="Status" formControlName="formReservationStatus"
      dataKey="value" optionLabel="label"></p-multiSelect>&nbsp;&nbsp;
    </span>
  }

  @if (showAdults) {
    <span class="my-2 d-block">
      <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'" [options]="adultsChilds"
        formControlName="formAdultsCount" defaultLabel="Select Adults" dataKey="id" optionLabel="name" display="chip"
        appendTo="body">
      </p-multiSelect>&nbsp;&nbsp;
    </span>
  }

  @if (showChilds) {
    <span class="my-2 d-block">
      <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'" [options]="adultsChilds"
        formControlName="formChildrensCount" defaultLabel="Select Childrens" dataKey="id" optionLabel="name" display="chip"
        appendTo="body">
      </p-multiSelect>&nbsp;&nbsp;
    </span>
  }

  @if (showDevelopments) {
    <span class="my-2 d-block">
      <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
        [options]="developments" formControlName="formDevelopmentIds" defaultLabel="Select Resort"
        dataKey="developmentId" optionLabel="addressDevelopmentName" display="chip" appendTo="body">
      </p-multiSelect>&nbsp;&nbsp;
    </span>
  }

  @if (showShortTermRentals) {
    <span class="my-2 d-block">
      <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'"
        [options]="shortTermRentals" formControlName="formShortTermRentalIds" defaultLabel="Select Property"
        dataKey="shortTermRentalId" optionLabel="propertyCode" display="chip" appendTo="body">
      </p-multiSelect>&nbsp;&nbsp;
    </span>
  }

  @if (showBedrooms) {
    <span class="my-2 d-block">
      <p-multiSelect autoWidth="false" [ngStyle]="{'minWidth':'175px'}" [scrollHeight]="'50vh'" [options]="bedrooms"
        formControlName="formBedrooms" defaultLabel="Select Bedrooms" dataKey="id" optionLabel="name" display="chip"
        appendTo="body">
      </p-multiSelect>&nbsp;&nbsp;
    </span>
  }

  <p-button label="{{searchLabel}}" (click)="searchClick()" class="my-2 d-block"></p-button>
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  <button pButton pRipple type="button" label="Reset" class="p-button-warning p-button-text my-2 d-block"
  (click)="form1.reset();"></button>
</form>
